import { render } from "./advisorProductAdvices.vue?vue&type=template&id=0fbdcf94&scoped=true&ts=true"
import script from "./advisorProductAdvices.vue?vue&type=script&lang=ts"
export * from "./advisorProductAdvices.vue?vue&type=script&lang=ts"

import "./advisorProductAdvices.vue?vue&type=style&index=0&id=0fbdcf94&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbdcf94"]])

export default __exports__